import { toast } from "react-toastify";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";

const GenerarCotizacionHyD = async ({ idCotizacion, setPagos, setServicios, services, setLoading, fechaInicio, onSubmit }) => {
  try {
    setLoading(true)
    const servicesList = [];
    const paymentsList = [];

    for (const service of services) {
      const response = await axios.post(`${BACKEND}/api/serviciosCotizaciones`, {
        servicio: service.id,
        cotizacion: idCotizacion,
        subarea: "CMS",
        responsable: service.encargado.id,
        planServicio: service.preciosUnitarios[0].plan.id,
        codigo: String(service.id),
        numeroItems: 1,
        fechaInicio: new Date(fechaInicio).toISOString(),
        fechaFin: new Date(new Date(fechaInicio).setFullYear(new Date(fechaInicio).getFullYear() + 1)).toISOString(),
        estado: "Por comenzar",
      });
      servicesList.push(response.data.doc);
    }

    for (let i = 0; i < 2; i++) {
      const response = await axios.post(`${BACKEND}/api/pagosCotizaciones`, {
        cotizacion: idCotizacion,
        fechaLimite: i === 0 ? fechaInicio : new Date(new Date(fechaInicio).setFullYear(new Date(fechaInicio).getFullYear() + 1)).toISOString(),
        precio: services.reduce((acc, service) => acc + (service.preciosUnitarios[0].precio ? service.preciosUnitarios[0].precio : 0), 0),
        percentage: 50,
        estado: "Pendiente"
      });
      paymentsList.push(response.data.doc);
    }

    setServicios(servicesList);
    setPagos(paymentsList);
    toast.success("Registros generados correctamente");
    onSubmit()
  } catch (error) {
    console.log(error)
    toast.error("Error al generar la cotización: " + error);
  } finally {
    setLoading(false)
  }
}

export default GenerarCotizacionHyD;

